import offlineFairInstance from "./axios-instances/offlineFairInstance";

export function fetchStudentDetails(payload) {
    const params = new URLSearchParams(payload);
    return offlineFairInstance.get(`/fairs/registrations?${params}`);
}

export function addNotesToStudent(studentID, notesData) {
    return offlineFairInstance.post(`/fairs/registrations/${studentID}/notes`, notesData);
}

export function fetchStudentNotes(studentID, payload) {
    const params = new URLSearchParams(payload);
    return offlineFairInstance.get(`/fairs/registrations/${studentID}/notes?${params.toString()}`);
}
